import styled from 'styled-components'
import { Alert as AlertComponent } from 'ui/src/components/alert'

export const Alert = styled(AlertComponent)`
    background: #000;
    border: none;
    width: 100%;
`

export const Container = styled.div`
    flex: 1;
    margin: 0 auto;
    max-width: 420px;
`
